import {VALID_PHONE_LENGTH} from './constants';

export function validateCellPhone(input?: string): boolean {
	if (!input) return false;

	const raw = input.replace(/\D/g, '');

	if (raw.length !== VALID_PHONE_LENGTH) return false;

	const withoutDDD = raw.slice(2);

	return withoutDDD.startsWith('9');
}
